import { Model } from '@vuex-orm/core'

export class SubstitutedLesson extends Model {
  static entity = 'substitutedLesson'

  static fields () {
    return {
      id: this.attr(),
      lesson_id: this.number(null),
      lesson_date: this.attr(null),
      target_id: this.number(null)
    }
  }
}

export default SubstitutedLesson
